// ========== LPO BUTTON GUARD ==========
// Désactive le bouton "Ajouter au panier" tant que LPO n'a pas chargé ses options
// Évite les ajouts au panier sans les composants (cadre, passe-partout)

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    // Sélecteur du bouton d'ajout au panier
    buttonSelector: '.product-form__submit[name="add"], #ProductSubmitButton',
    // Sélecteur qui indique que LPO est chargé (les options sont dans le DOM)
    lpoReadySelector: '[data-live-options] .cl-po--option',
    // Texte du bouton quand désactivé
    disabledText: 'Chargement des options...',
    // Timeout maximum d'attente (ms) - après ça, on réactive le bouton quand même
    maxWaitTime: 15000,
    // Intervalle de vérification (ms)
    checkInterval: 100
  };

  // Trouver le bouton d'ajout au panier
  function getAddToCartButton() {
    return document.querySelector(CONFIG.buttonSelector);
  }

  // Vérifier si LPO est chargé
  function isLPOReady() {
    const lpoOptions = document.querySelectorAll(CONFIG.lpoReadySelector);
    return lpoOptions.length > 0;
  }

  // Désactiver le bouton
  function disableButton(button) {
    if (!button || button.dataset.lpoGuardDisabled === 'true') return;

    // Sauvegarder l'état original
    button.dataset.lpoGuardDisabled = 'true';
    button.dataset.originalText = button.querySelector('span')?.textContent || button.textContent;
    
    // Désactiver
    button.disabled = true;
    button.style.opacity = '0.6';
    button.style.cursor = 'not-allowed';
    
    // Changer le texte
    const textSpan = button.querySelector('span');
    if (textSpan) {
      textSpan.textContent = CONFIG.disabledText;
    }
  }

  // Réactiver le bouton
  function enableButton(button) {
    if (!button || button.dataset.lpoGuardDisabled !== 'true') return;

    // Restaurer l'état
    button.disabled = false;
    button.style.opacity = '';
    button.style.cursor = '';
    
    // Restaurer le texte
    const textSpan = button.querySelector('span');
    if (textSpan && button.dataset.originalText) {
      textSpan.textContent = button.dataset.originalText;
    }
    
    // Nettoyer les data attributes
    delete button.dataset.lpoGuardDisabled;
    delete button.dataset.originalText;
  }

  // Initialisation
  function init() {
    const button = getAddToCartButton();
    
    // Si pas de bouton, on est probablement pas sur une page produit
    if (!button) return;

    // Si LPO est déjà chargé, rien à faire
    if (isLPOReady()) {
      return;
    }

    // Désactiver le bouton
    disableButton(button);

    // Observer le DOM pour détecter quand LPO charge ses options
    const startTime = Date.now();
    
    const checkLPO = setInterval(() => {
      // Timeout atteint
      if (Date.now() - startTime > CONFIG.maxWaitTime) {
        clearInterval(checkLPO);
        enableButton(button);
        console.warn('LPO Button Guard: Timeout atteint, bouton réactivé');
        return;
      }

      // LPO est prêt
      if (isLPOReady()) {
        clearInterval(checkLPO);
        enableButton(button);
      }
    }, CONFIG.checkInterval);
  }

  // Lancer dès que le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Aussi observer les changements de page (pour les thèmes SPA/AJAX)
  // Utile si le client navigue entre produits sans rechargement complet
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        const button = getAddToCartButton();
        if (button && !button.dataset.lpoGuardDisabled && !isLPOReady()) {
          init();
          break;
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();